import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Box, Flex, Button } from "@chakra-ui/react";
import { PageTitle } from "../../../components/PageTitle/PageTitle";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router-dom";
import { EventManagerTab } from "../EventManager";
import { useStores } from "../../../stores/setup/use-store";
import { SCREEN_HORIZONTAL_SPACING } from "../../../constants";

interface InsightManagerProps {}

const InsightManager: React.FC<InsightManagerProps> = () => {
  const {
    dataStores: {
      operationRuleStore,
      operationRuleLocationStore,
      operationRuleLocationInsightStore,
    },
  } = useStores();
  const { t } = useTranslation("translation", {
    keyPrefix: "oceanWeatherIntelligence.insightManager",
  });
  let history = useHistory();

  useEffect(() => {
    if (operationRuleStore.operationRules.length === 0) {
      operationRuleStore.getOperationRulesApi().then((dashboards) => {
        if (!dashboards?.length) {
          operationRuleLocationStore.setHasLocations(false);
          operationRuleLocationInsightStore.setHasInsights(false);
        } else {
          operationRuleLocationStore.setHasLocations(true);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box mt={8} mx={SCREEN_HORIZONTAL_SPACING}>
      <Flex>
        <Button
          onClick={() => history.push("/operation-insights")}
          size="small"
          mb={4}
          mr={2}
          layerStyle="lightOcean"
          _hover={{ layerStyle: "lightOcean" }}
          leftIcon={<ArrowBackIcon style={{ marginLeft: "6px" }} />}
        ></Button>
        <PageTitle text={t("insightManager")} />
      </Flex>
      <EventManagerTab />
    </Box>
  );
};

export default observer(InsightManager);
